export const VERY_HIGH_CONFIDENCE = 0.95

const CONFIDENCE_AUTO_FIELDS = new Set(['room', 'class_name', 'time_slot', 'lesson_number'])

const HEURISTIC_SOURCES = new Set([
  'orphan_combine',
  'orphan_inherit',
  'orphan_pattern',
  'cell_phrase_consumed',
  'cell_phrase_match',
  'template_multi',
  'template_pattern_deferred_partial',
  'template_pattern_unconfirmed_structural',
  'structural_pattern',
  'fallback',
  'subject_family_match',
  'cell_phrase_family_match',
])

export function shouldAutoConfirmVeryHighConfidence(token: {
  field?: string | null
  confidence?: number | null
  source?: string | null
  pattern_source?: string | null
}): boolean {
  const field = token.field
  if (!field || !CONFIDENCE_AUTO_FIELDS.has(field)) return false
  const source = token.source || token.pattern_source
  if (source && HEURISTIC_SOURCES.has(source)) return false
  return typeof token.confidence === 'number' && token.confidence >= VERY_HIGH_CONFIDENCE
}
